import Vue from "vue";
import { mapState } from "vuex";

import comboComponent from "@/components/child/form/combo.vue";
import { Component, Prop } from "@/decorators";
import LinkPagamentoModel from "@/models/financeiro/gatewayPagamento/linkPagamentoModel";
import UsuarioModel from "@/models/usuarioModel";
import configuracaoGatewayPagamentoService from "@/services/configuracaoGatewayPagamentoService";
import LinkPagamentoService from "@/services/linkPagamentoService";
import { AppState } from "@/store/store";

import "../crud/crud.scss";

@Component({
    components: {
        comboComponent,
    },
    computed: {
        ...mapState({
            usuarioLogado: (state: AppState) => state.session.usuarioLogado,
        }),
    },
})
export default class LinkPagamentoComponent extends Vue {
    // State computed props
    usuarioLogado: UsuarioModel;

    service = new LinkPagamentoService();
    linkPagamento = "";

    gateway = null;
    gatewaysOptions = [];

    @Prop(Number) vendaId: number;

    private async copiarTexto() {
        await navigator.clipboard.writeText(this.linkPagamento);

        this.$notifySuccess(this.$t("__.ts.linkCopiado") as string);
    }

    private async load() {
        try {
            if (this.vendaId) {
                const retorno = await this.service
                    .getLinkPagamentoAtivoByVendaId(this.vendaId)
                    .withLoading()
                    .resolveWithJSON<LinkPagamentoModel>();

                if (retorno) {
                    this.linkPagamento = retorno.linkPagamento;
                }
            }
        } catch {}
    }

    private async criarLinkPagamento() {
        try {
            const isValid = await this.$validator.validateAll();
            if (isValid) {
                if (this.linkPagamento) {
                    const response = await this.$showQuestion(
                        this.$t("__.ts.atencao"),
                        this.$t("__.ts.desejaGerarNovoLink"),
                    );

                    if (response) {
                        const retorno = await this.service
                            .criarLinkPagamento(this.vendaId, this.gateway)
                            .withLoading()
                            .resolveWithJSON<LinkPagamentoModel>();

                        if (retorno) {
                            this.linkPagamento = retorno.linkPagamento;

                            this.$notifySuccess(this.$t("__.ts.linkPagamentoAtualizado") as string);
                        }
                    }
                } else {
                    const retorno = await this.service
                        .criarLinkPagamento(this.vendaId, this.gateway)
                        .withLoading()
                        .resolveWithJSON<LinkPagamentoModel>();

                    if (retorno) {
                        this.linkPagamento = retorno.linkPagamento;
                    }
                }
            } else {
                this.$focusErrorField();
            }
        } catch {}
    }

    private async mounted() {
        this.gatewaysOptions = await configuracaoGatewayPagamentoService.comboCached(this.usuarioLogado.franquiaId);

        if (this.gatewaysOptions.length === 1) {
            this.gateway = this.gatewaysOptions[0].value;
        }

        this.load();
    }
}
